import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './Tooltip.module.sass';

const Tooltip = React.forwardRef(
    ({ children }: Props, ref: any
) => {
    const [popperRef, setPopperRef] = useState<any>(null);
    const [popperArrowRef, setPopperArrowRef] = useState<any>(null);
    const { styles: popperStyle, attributes } = usePopper(
        ref,
        popperRef,
        {
            placement: 'top',
            modifiers: [
                {
                    name: 'arrow',
                    options: {
                        element: popperArrowRef
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10]
                    }
                }
            ],
        }
    );

    const cssClasses = CssHelper.createCssClass(`
        ${styles['tooltip']}
    `);

    return ReactDOM.createPortal(
        <div
            ref={setPopperRef}
            className={cssClasses}
            style={popperStyle.popper}
            {...attributes.popper}
        >
            { children }
            <div
                ref={setPopperArrowRef}
                className={styles['tooltip__arrow']}
                style={popperStyle.arrow}
            />
        </div>,
        // @ts-ignore
        document.getElementById('root')
    );
});

interface Props {
    children: any
}

export default React.memo(Tooltip);